import React, { useState } from "react";
import { CustomIconButton, CustomTooltip, icon } from "../../../../../../common/components";
import styles from "./Row.module.css";
import { translate, translateDate } from "../../../../../../common/providers";

const HistoryRow = ({ history, onDownloadTrace, onForceCriteria }) => {
	const [isRelaunching, setIsRelaunching] = useState(false);
	const handleDownload = () => {
		if (onDownloadTrace && typeof onDownloadTrace === "function") {
			onDownloadTrace(history.id);
		}
	};
	const handleForceCriteria = () => {
		if (onForceCriteria && typeof onForceCriteria === "function") {
			setIsRelaunching(true);
			onForceCriteria(history);
			setTimeout(() => {
				setIsRelaunching(false);
			}, 1000);
		}
	};
	return (
		<div className={styles.row}>
			<div className={styles.rowFixed}>{history.id}</div>
			<CustomTooltip showWhenOverflow title={history.workflowName}>
				<div className={styles.rowText}>{history.workflowName}</div>
			</CustomTooltip>
			<CustomTooltip showWhenOverflow title={history.projectName}>
				<div className={styles.rowText}>{history.projectName}</div>
			</CustomTooltip>
			<CustomTooltip showWhenOverflow title={history.waitingForManualEvent}>
				<div className={styles.rowText}>{history.waitingForManualEvent}</div>
			</CustomTooltip>
			<CustomTooltip showWhenOverflow title={history.status}>
				<div className={styles.rowText}>{history.status}</div>
			</CustomTooltip>
			<div className={styles.rowFixed}>{translateDate(history.created)}</div>
			<div className={styles.rowAction}>
				<CustomIconButton
					disabled={isRelaunching}
					icon={icon.faRedoAlt}
					size="sm"
					tooltip={translate("common:btn.relaunch")}
					variant="outlined"
					onClick={handleForceCriteria}
				/>
				<CustomIconButton icon={icon.faDownload} size="sm" variant="outlined" onClick={handleDownload} />
			</div>
		</div>
	);
};

export default HistoryRow;
